import React, { ReactNode } from "react";
import { useLocalStorage } from "usehooks-ts";

type TContext = {
  isLogin: boolean;
  login: () => void;
  logout: () => void;
  toggleLogin: () => void;
};

const LoginContext = React.createContext<TContext>({
  isLogin: false,
  login: () => {},
  logout: () => {},
  toggleLogin: () => {},
});

type LoginProviderProps = {
  children: ReactNode;
};

export const LoginContextProvider: React.FC<LoginProviderProps> = ({ children }) => {
  const [isLogin, setIsLogin] = useLocalStorage("isLogin", false);

  function login() {
    setIsLogin(true);
  }

  function logout() {
    setIsLogin(false);
  }

  function toggleLogin() {
    setIsLogin(!isLogin);
  }

  const loginValue: TContext = {
    isLogin,
    login,
    logout,
    toggleLogin,
  };

  return (
    <LoginContext.Provider value={loginValue}>
      {children}
    </LoginContext.Provider>
  );
};

export default LoginContext;
